/**
 * Dependencies.
 */
import { authService } from '@prz-dp/services';
import { NavigationGuardNext, Route, RouteConfig } from 'vue-router';

import AppDocumentScene from '@/modules/document/scenes/app-document/app-document.scene.vue';
import ScanCodeScene from '@/modules/document/scenes/scan-code/scan-code.scene.vue';
import SelectTypeScene from '@/modules/document/scenes/select-type/select-type.scene.vue';
import applicationConstant from '@/modules/main/constants/application.constant';
import store from '@/plugins/store.plugin';

/**
 * Routes.
 */
export default [
  {
    beforeEnter: (to: Route, from: Route, next: NavigationGuardNext) => {
      let { auth } = applicationConstant;

      auth = {
        ...auth,
        realm: 'intranet'
      };

      authService.setup({
        authOptions: auth,
        domain: '',
        store
      });

      authService.init(next, null, null, to);
    },
    children: [
      {
        component: ScanCodeScene,
        name: 'ScanCodeDocument',
        path: ''
      },
      {
        component: SelectTypeScene,
        name: 'SelectTypeDocument',
        path: ':code'
      }
    ],
    component: AppDocumentScene,
    path: '/document'
  }
] as RouteConfig[];
